import { Payment } from '../types'
import i18n from '../utils/i18n.utils'

export const handleGetMonthLabelByNumber = (numberToParse: string) => {
  if (numberToParse === '01') {
    return i18n.t('payments-to-review-management:complianceProcess.january')
  } else if (numberToParse === '02') {
    return i18n.t('payments-to-review-management:complianceProcess.feburary')
  } else if (numberToParse === '03') {
    return i18n.t('payments-to-review-management:complianceProcess.march')
  } else if (numberToParse === '04') {
    return i18n.t('payments-to-review-management:complianceProcess.april')
  } else if (numberToParse === '05') {
    return i18n.t('payments-to-review-management:complianceProcess.may')
  } else if (numberToParse === '06') {
    return i18n.t('payments-to-review-management:complianceProcess.june')
  } else if (numberToParse === '07') {
    return i18n.t('payments-to-review-management:complianceProcess.july')
  } else if (numberToParse === '08') {
    return i18n.t('payments-to-review-management:complianceProcess.august')
  } else if (numberToParse === '09') {
    return i18n.t('payments-to-review-management:complianceProcess.september')
  } else if (numberToParse === '10') {
    return i18n.t('payments-to-review-management:complianceProcess.october')
  } else if (numberToParse === '11') {
    return i18n.t('payments-to-review-management:complianceProcess.november')
  } else if (numberToParse === '12') {
    return i18n.t('payments-to-review-management:complianceProcess.december')
  } else {
    return ''
  }
}

export const handleGetPaymentsWithAlertsToQuery = (customerCompanyId: string, limit?: number) => {
  const belongsTo = String(customerCompanyId)
  const requestedLimit = Number(limit ?? 20000)
  const LIMIT = Math.min(requestedLimit, 50000)

  const pipeline = [
    {
      $match: {
        belongsTo,
        // deleted: { $ne: true },
        status: { $nin: ['for-review', 'deleted'] },
        $or: [{ 'novelties.type': 'background-research' }, { complianceResolutionData: { $exists: true } }, { 'tags.type': { $in: [1, 2, 3, 5, '1', '2', '3', '5'] } }]
      }
    },
    {
      $project: {
        _id: 1,
        status: 1,
        amount: 1,
        createdAt: 1,
        paidAt: 1,
        belongsTo: 1,
        customerRegisteredFullName: 1,
        referenceNumber: 1,
        complianceResolutionData: 1,
        novelties: {
          $map: {
            input: {
              $filter: {
                input: { $ifNull: ['$novelties', []] },
                as: 'n',
                cond: { $eq: ['$$n.type', 'background-research'] }
              }
            },
            as: 'n',
            in: { type: '$$n.type' }
          }
        },
        tags: {
          $map: {
            input: {
              $filter: {
                input: { $ifNull: ['$tags', []] },
                as: 't',
                cond: { $in: ['$$t.type', [0, 3, 4, 5, 6]] }
              }
            },
            as: 't',
            in: {
              type: '$$t.type',
              status: { $ifNull: ['$$t.status', null] }
            }
          }
        },
        hasComplianceResolutionData: {
          $cond: [{ $gt: [{ $type: '$complianceResolutionData' }, 'missing'] }, true, false]
        }
      }
    },
    { $sort: { createdAt: -1, _id: -1 } },
    { $limit: LIMIT }
  ]

  const pipelineHardStop = [
    {
      $match: {
        belongsTo,
        deleted: { $ne: true },
        status: { $nin: ['for-review', 'deleted'] },
        $or: [{ 'novelties.type': 'background-research' }, { complianceResolutionData: { $exists: true } }, { 'tags.type': { $in: [0, 4, 6, '0', '4', '6'] } }]
        // 'tags.type': { $in: [0, 4, 6, '0', '4', '6'] },
        // $or: [{ 'novelties.type': 'background-research' }, { complianceResolutionData: { $exists: true } }]
        // $or: [{ 'novelties.type': 'background-research' }, { complianceResolutionData: { $exists: true } }, { 'tags.type': { $in: [0, 3, 4, 5, 6] } }]
      }
    },
    { $sort: { createdAt: -1, _id: -1 } },
    { $limit: LIMIT },
    {
      $lookup: {
        from: 'supporttickets',
        let: { pidStr: { $toString: '$_id' } },
        pipeline: [
          {
            $match: {
              entityType: 'payment',
              deleted: false,
              $expr: { $eq: ['$entityId', '$$pidStr'] }
            }
          },
          { $sort: { updatedAt: -1, _id: -1 } },
          {
            $project: {
              _id: 1,
              status: 1,
              hasToResponse: 1,
              updatedAt: 1,
              lastComplianceComment: {
                $let: {
                  vars: { lc: { $arrayElemAt: ['$complianceComments', -1] } },
                  in: {
                    description: '$$lc.description',
                    date: '$$lc.date',
                    sentBy: '$$lc.sentBy'
                  }
                }
              }
            }
          },
          { $limit: 1 }
        ],
        as: 'supportTicket'
      }
    },
    { $addFields: { supportTicket: { $ifNull: [{ $arrayElemAt: ['$supportTicket', 0] }, null] } } },
    {
      $project: {
        _id: 1,
        status: 1,
        amount: 1,
        createdAt: 1,
        paidAt: 1,
        belongsTo: 1,
        customerRegisteredFullName: 1,
        referenceNumber: 1,
        complianceResolutionData: 1,
        tags: {
          $map: {
            input: {
              $filter: {
                input: { $ifNull: ['$tags', []] },
                as: 't',
                cond: { $in: ['$$t.type', [0, 4, 6]] }
              }
            },
            as: 't',
            in: {
              type: '$$t.type',
              status: { $ifNull: ['$$t.status', null] }
            }
          }
        },
        hasComplianceResolutionData: {
          $cond: [{ $gt: [{ $type: '$complianceResolutionData' }, 'missing'] }, true, false]
        },
        supportTicket: 1
      }
    }
  ]

  return { pipeline, pipelineHardStop }
}

export const upsertPaymentWithLimitAtStart = (arr: readonly Payment[], item: Payment, limit: number) => {
  if (!Number.isFinite(limit) || limit <= 0) return []

  const idx = arr.findIndex((x) => x._id === item._id)

  let next: Array<Payment>

  if (idx >= 0) {
    next = arr.slice()
    next[idx] = item
  } else {
    next = [item, ...arr]
  }

  return next.length > limit ? next.slice(0, limit) : next
}

export const getJsonSize = (json: unknown) => {
  const str = JSON.stringify(json)
  const bytes = new TextEncoder().encode(str).length

  return {
    bytes,
    kb: +(bytes / 1024).toFixed(2),
    mb: +(bytes / (1024 * 1024)).toFixed(2),
    gb: +(bytes / (1024 * 1024 * 1024)).toFixed(2)
  }
}
